<template>
  <div class="flex flex-col min-h-screen w-full bg-white">
    <cabecera-gob-mx />

    <main class="flex-1">
      <section class="px-10 pt-20 mx-auto max-w-5xl space-y-5">
        <h1 class="text-5xl font-bold pt-10">
          Ayuda
        </h1>
      </section>

      <section class="py-10">
        <div class="p-10 mx-auto max-w-5xl space-y-5">
          <h2 class="text-3xl font-bold">
            Material de apoyo
          </h2>
          <p>
            El material de apoyo fue creado para reforzar las indicaciones revisadas durante la capacitación 
            y facilitar la consulta de dudas relacionadas con la aplicación de los cuestionarios y el uso de Apporta.
          </p>
          <p>
            Con la finalidad de que las y los facilitadores puedan consultarlo durante el proceso de levantamiento, 
            recomendamos guardarlos directamente en los dispositivos con los que se efectuará el trabajo en campo, 
            para tenerlos siempre disponibles aún sin conexión a internet.
          </p>

          <p class="pt-10">
            <span class="block text-xl font-bold">
              Manual de aplicación de los cuestionarios
            </span>
            El presente manual de aplicación de los cuestionarios orienta al personal responsable del levantamiento de
            información en el uso correcto de los instrumentos del Sistema de Indicadores de Evaluación de Impacto del
            Programa Sembrando Vida (PSV). Establece criterios técnicos y operativos para que todas las entrevistas se
            realicen de manera uniforme y la información recopilada sea confiable, consistente y comparable.
          </p>
          <p class="flex gap-5">
            <a href="/ayuda/manual_de_aplicacion_de_los_cuestionarios.pdf" download  
              class="px-5 py-3 bg-secondary-color hover:bg-primary-color text-white rounded-xl inline-flex items-center gap-3">
              <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M359-457h38.5v-79h40q16.36 0 27.43-11.07T476-574.5v-40q0-16.36-11.07-27.43T437.5-653H359v196Zm38.5-117.5v-40h40v40h-40ZM515-457h78.35Q610-457 621-468.25t11-27.25v-119q0-16.36-11.07-27.43T593.5-653H515v196Zm38.5-38.5v-119h40v119h-40Zm119 38.5H711v-79h41.5v-38.5H711v-40h41.5V-653h-80v196ZM315-240q-30.94 0-52.97-22.03Q240-284.06 240-315v-480q0-30.94 22.03-52.97Q284.06-870 315-870h480q30.94 0 52.97 22.03Q870-825.94 870-795v480q0 30.94-22.03 52.97Q825.94-240 795-240H315Zm0-75h480v-480H315v480ZM165-90q-30.94 0-52.97-22.03Q90-134.06 90-165v-555h75v555h555v75H165Zm150-705v480-480Z"/></svg>
              Descarga el Manual de aplicación de los cuestionarios (PDF, 11.53MB)
            </a>
          </p>
        
          <p class="pt-10">
            <span class="block text-xl font-bold">Video 1</span>
            En este primer video del sistema de indicadores de evaluación de impacto del Programa Sembrando Vida, 
            veremos <b>qué debes considerar antes de iniciar una entrevista y cómo aplicarla sin influir en las respuestas</b>.
          </p>
          
          <div class="rounded-xl overflow-hidden shadow-xl border">
            <video controls poster="/ayuda/video1.webp" class="w-full">
              <source src="/ayuda/video1_aplicacion_de_los_cuestionarios.mp4" type="video/mp4">
              Lo sentimos, tu navegador no soporta videos embebidos, pero puedes 
              <a href="/ayuda/video1_aplicacion_de_los_cuestionarios.mp4">descargar el video 1 en éste enlace</a>.
            </video>
          </div>
          <p>
            <a 
              href="/ayuda/video1_aplicacion_de_los_cuestionarios.mp4" download 
              class="px-5 py-3 bg-secondary-color hover:bg-primary-color text-white rounded-xl inline-flex items-center gap-3">
              <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="m453.5-382 271-174-271-174v348ZM315-240q-30.94 0-52.97-22.03Q240-284.06 240-315v-480q0-30.94 22.03-52.97Q284.06-870 315-870h480q30.94 0 52.97 22.03Q870-825.94 870-795v480q0 30.94-22.03 52.97Q825.94-240 795-240H315Zm0-75h480v-480H315v480ZM165-90q-30.94 0-52.97-22.03Q90-134.06 90-165v-555h75v555h555v75H165Zm150-705v480-480Z"/></svg>
              Descarga video 1 (Video mp4, 297.3 MB)
            </a>
          </p>

          <p class="pt-10">
            <span class="block text-xl font-bold">Video 2</span>
            En este segundo video del sistema de indicadores de evaluación de impacto del Programa Sembrando Vida, 
            veremos <b>cómo aclarar y registrar correctamente las respuestas</b>.
          </p>
          <div class="rounded-xl overflow-hidden shadow-xl border">
            <video controls poster="/ayuda/video2.webp" class="w-full">
              <source src="/ayuda/video2_aplicacion_de_los_cuestionarios.mp4" type="video/mp4">
              Lo sentimos, tu navegador no soporta videos embebidos, pero puedes 
              <a href="/ayuda/video2_aplicacion_de_los_cuestionarios.mp4">descargar el video 2 en éste enlace</a>.
            </video>
          </div>
          <p>
            <a 
              href="/ayuda/video2_aplicacion_de_los_cuestionarios.mp4" download 
              class="px-5 py-3 bg-secondary-color hover:bg-primary-color text-white rounded-xl inline-flex items-center gap-3">
              <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="m453.5-382 271-174-271-174v348ZM315-240q-30.94 0-52.97-22.03Q240-284.06 240-315v-480q0-30.94 22.03-52.97Q284.06-870 315-870h480q30.94 0 52.97 22.03Q870-825.94 870-795v480q0 30.94-22.03 52.97Q825.94-240 795-240H315Zm0-75h480v-480H315v480ZM165-90q-30.94 0-52.97-22.03Q90-134.06 90-165v-555h75v555h555v75H165Zm150-705v480-480Z"/></svg>
              Descarga video 2 (Video mp4, 220.28 MB)
            </a>
          </p>


          <p class="pt-10">
            <span class="block text-xl font-bold">Video 3</span>
            En este tercer video del sistema de indicadores de evaluación de impacto del Programa Sembrando Vida, 
            veremos <b>como seguir correctamente el flujo del cuestionario, 
            qué hacer ante algunas situaciones que pueden presentarse durante la entrevista y 
            cómo cerrarla correctamente</b>.
          </p>
          <div class="rounded-xl overflow-hidden shadow-xl border">
            <video controls poster="/ayuda/video3.webp" class="w-full">
              <source src="/ayuda/video3_aplicacion_de_los_cuestionarios.mp4" type="video/mp4">
              Lo sentimos, tu navegador no soporta videos embebidos, pero puedes 
              <a href="/ayuda/video3_aplicacion_de_los_cuestionarios.mp4">descargar el video 3 en éste enlace</a>.
            </video>
          </div>
          <p>
            <a 
              href="/ayuda/video3_aplicacion_de_los_cuestionarios.mp4" download 
              class="px-5 py-3 bg-secondary-color hover:bg-primary-color text-white rounded-xl inline-flex items-center gap-3">
              <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="m453.5-382 271-174-271-174v348ZM315-240q-30.94 0-52.97-22.03Q240-284.06 240-315v-480q0-30.94 22.03-52.97Q284.06-870 315-870h480q30.94 0 52.97 22.03Q870-825.94 870-795v480q0 30.94-22.03 52.97Q825.94-240 795-240H315Zm0-75h480v-480H315v480ZM165-90q-30.94 0-52.97-22.03Q90-134.06 90-165v-555h75v555h555v75H165Zm150-705v480-480Z"/></svg>
              Descarga video 3 (Video mp4, 208.96 MB)
            </a>
          </p>

        </div>
      </section>

      <section class="py-10 bg-gray-100">
        <div class="p-10 mx-auto max-w-5xl space-y-5">
          <h2 class="text-3xl font-bold">Instalación de la aplicación Apporta</h2>
          <img src="@/assets/logos-instituciones/icon-only.png" alt="" class="h-20 rounded-full">
          <ol class="space-y-3 list-decimal ml-5">
            <li>
              <b class="text-lg font-bold">Descarga el archivo APK:</b>
              <ul class="space-y-1 ml-5 list-disc">
                <li>Guarda el archivo APK en el dispositivo.</li>
              </ul>
            </li>
            <li>
              <b class="text-lg font-bold">Habilita el permiso de fuentes desconocidas:</b>
              <ul class="space-y-1 ml-5 list-disc">
                <li>
                  Entra a los <b>Ajustes</b> o <b>Configuración</b> de tu tableta.
                </li>
                <li>
                  Ve a la sección de <b>Aplicaciones</b> y busca <b>Acceso especial a aplicaciones</b> 
                  (en algunas versiones o marcas está dentro de un menú desplegable o de seguridad).
                </li>
                <li>
                  Selecciona <b>Instalar aplicaciones desconocidas</b>.
                </li>
                <li>
                  Busca la aplicación que usaste para descargar el archivo (por ejemplo, Chrome o tu Gestor de archivos) 
                  y actívala seleccionando <b>Permitir desde esta fuente</b> o <b>Confiar en esta fuente</b>.
                </li>
              </ul>
            </li>
            <li>
              <b class="text-lg font-bold">Localiza e instala el APK:</b>
              <ul class="space-y-1 ml-5 list-disc">
                <li>Abre tu aplicación de <b>Gestor de archivos</b> (como Files by Google o Mis archivos) y entra a la carpeta de <b>Descargas</b>.</li>
                <li>Toca sobre el archivo APK descargado.</li>
                <li>Aparecerá una ventana emergente preguntando si deseas instalar la aplicación; presiona <b>Instalar</b> y espera a que finalice el proceso.</li>
              </ul>
            </li>
          </ol>
          <p class="pt-10">
            Apporta es una plataforma desarrollada por CONAHCYT y CentroGeo diseñada para facilitar el levantamiento de datos georeferenciados 
            con el propósito de abordar problemas prioritarios de manera eficiente.
          </p>
        </div>
      </section>

      <section class="py-10">
        <div class="p-10 mx-auto max-w-5xl space-y-2">
          <h2 class="text-3xl font-bold">
            ¿Necesitas ayuda?
          </h2>
          <p class="text-xl pt-10">
            <a href="https://wa.me/525631897690?text=Soporte%20Apporta%20Sembrando%20Vida"
              class="px-5 py-3 bg-secondary-color hover:bg-primary-color text-white rounded-xl inline-flex items-center gap-3">
              <svg aria-hidden="true" width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.5 29C11.964 29 9.47433 28.3268 7.26959 27.0517L1.62061 29L2.78175 23.0162C0.958118 20.523 0 17.5881 0 14.5C0 6.50381 6.50381 0 14.5 0C22.4962 0 29 6.50381 29 14.5C29 22.4962 22.4962 29 14.5 29ZM7.5296 24.6831L7.9677 24.9574C9.93736 26.1933 12.1955 26.8451 14.5036 26.8451C21.3101 26.8451 26.8451 21.3066 26.8451 14.5036C26.8451 7.70057 21.3066 2.15844 14.5 2.15844C7.69344 2.15844 2.15844 7.69344 2.15844 14.5C2.15844 17.2675 3.06669 19.8925 4.77991 22.0866L5.08266 22.4748L4.44866 25.7445L7.5296 24.6831Z" fill="currentColor"/>
                <path d="M7.18052 8.9294C7.18052 8.9294 8.03178 7.44057 8.72633 7.35865C9.42088 7.27317 10.3113 7.27317 10.5535 7.72551C10.7957 8.17786 11.8714 10.8136 11.8714 10.8136C11.8714 10.8136 12.0566 11.2659 11.7717 11.7076C11.4867 12.1457 10.8527 12.7832 10.8527 12.7832C10.8527 12.7832 10.5001 13.2356 10.8527 13.72C11.2053 14.2008 11.7574 15.0877 12.8936 16.2204C14.0298 17.3566 16.2061 18.1651 16.2061 18.1651C16.2061 18.1651 16.5195 18.2078 16.7154 18.0084C16.9149 17.8089 17.9905 16.4661 17.9905 16.4661C17.9905 16.4661 18.336 16.0209 18.9095 16.2809C19.4829 16.5445 21.969 17.784 21.969 17.784C21.969 17.784 22.2611 17.8908 22.2611 18.3289C22.2611 18.767 22.083 19.8427 21.7197 20.206C21.3564 20.5693 20.295 21.6877 18.6993 21.6877C17.1036 21.6877 13.3032 20.3876 11.2766 18.3645C9.24991 16.3379 7.45121 14.2863 7.02736 12.4164C6.60351 10.5464 6.6605 9.7023 7.18052 8.93296V8.9294Z" fill="currentColor"/>
              </svg>
              Envía un mensaje por WhatsApp al 56-3189-7690
            </a>
          </p>
          <p class="pt-10">
            Para soporte técnico puede enviar un correo y con gusto le atenderemos.
          </p>
          <p class="flex gap-5">
            <a href="mailto:psp.iruiz@centrogeo.edu.mx?cc=umorales@centrogeo.edu.mx&subject=Soporte%20Tecnico%20Apporta" 
              class="px-5 py-3 text-secondary-color border border-current hover:text-primary-color inline-flex items-center rounded-xl gap-3">
              <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280L160-640v400h640v-400L480-440Zm0-80 320-200H160l320 200ZM160-640v-80 480-400Z"/></svg>
              psp.iruiz@centrogeo.edu.mx
            </a>  
          </p>
        </div>
      </section>

      <section class="py-10 bg-gray-100">
        <div class="p-10 mx-auto max-w-5xl space-y-5">
          <img src="@/assets/logos-instituciones/centro-geo.svg" alt="CentroGeo" class="h-20">
          <p class="pt-10">
            <b class="block">Responsable del proyecto</b>
            <em class="block">Dra. Adriana Lizzette Luna Nieves</em>
          </p>
          <p>
            <b class="block">Personas técnicas asociadas al proyecto</b>
            <em class="block">Lic. Arturo Alcazar Villalobos</em>
            <em class="block">Lic. Jonathan Elías Leal Mejía</em>
            <em class="block">Lic. Karina Acosta Acosta</em>
            <em class="block">Mtra. Mariela Salinas Rodríguez</em>
          </p>
          <p>
            <b class="block">Colaboradoras y colaboradores</b>
            <em class="block">Dra. Alejandra Aline Pingarroni Martín del Campo</em>
            <small>Facultad de Estudios Superiores Iztacala, Universidad Nacional Autónoma de México</small>
            <em class="block">Dr. Arnulfo Blanco García</em>
            <small>Facultad de Biología, Universidad Michoacana de San Nicolás de Hidalgo</small>
            <em class="block">Dr. Edgar J. González</em>
            <small>Facultad de Ciencias, Universidad Nacional Autónoma de México</small>
          </p>
        </div>
      </section>

    </main>

    <piedepagina-gob-mx />
  </div>
</template>

<style scoped>
</style>

<script>
import CabeceraGobMx from "./CabeceraGobMx.vue";
import PiedepaginaGobMx from "./PiedepaginaGobMx.vue";

export default {
  data() {
    return {};
  },
  components: {
    CabeceraGobMx,
    PiedepaginaGobMx,
  },
  computed: {},
  methods: {},
};
</script>